import { useEffect, useState } from "react";
import "./Countdown.css";

/* =================================================
🔴 CHANGE EVENT DATES HERE
-------------------------------------------------
Timezone: +05:30 (India Standard Time)
================================================= */

// Hackathon starts on: 18 FEB 2026 — 10:00 AM IST
const START_DATE = new Date("2026-02-18T10:00:00+05:30");

// Hackathon ends on: 20 FEB 2026 — 12:00 PM IST
const END_DATE = new Date("2026-02-20T12:00:00+05:30");

/* ================================================= */

export default function Countdown() {
    const [time, setTime] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        danger: false,
        isLive: false,
        isOver: false,
    });

    useEffect(() => {
        const calculateTime = () => {
            const now = Date.now();

            // 1. Check if the Hackathon is completely over
            if (now >= END_DATE.getTime()) {
                setTime({
                    days: 0,
                    hours: 0,
                    minutes: 0,
                    seconds: 0,
                    danger: false,
                    isLive: false,
                    isOver: true,
                });
                return;
            }

            // 2. Check if the Hackathon is currently Live
            const diffToStart = START_DATE.getTime() - now;
            if (diffToStart <= 0) {
                setTime({
                    days: 0,
                    hours: 0,
                    minutes: 0,
                    seconds: 0,
                    danger: false,
                    isLive: true,
                    isOver: false,
                });
                return;
            }

            // 3. Normal Countdown Mode
            const days = Math.floor(diffToStart / (1000 * 60 * 60 * 24));

            setTime({
                days,
                hours: Math.floor((diffToStart / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((diffToStart / (1000 * 60)) % 60),
                seconds: Math.floor((diffToStart / 1000) % 60),
                danger: days < 1, // 🔴 last 24 hours
                isLive: false,
                isOver: false,
            });
        };

        calculateTime();
        const interval = setInterval(calculateTime, 1000);

        return () => clearInterval(interval);
    }, []);

    // 🚀 ENDED STATE
    if (time.isOver) {
        return (
            <div className="countdown-ended">
                HACKATHON ENDED <br />
                <span style={{ fontSize: "1.5rem", fontWeight: "normal", color: "#ccc" }}>
                    See you next year <br />
                    👋✨
                </span>
            </div>
        );
    }

    // 🚀 LIVE STATE
    if (time.isLive) {
        return (
            <div className="countdown-live">
                🚀 HACKATHON IS LIVE 🚀
            </div>
        );
    }

    // ⏳ COUNTDOWN STATE
    return (
        <div className={`countdown ${time.danger ? "danger" : ""}`}>
            <TimeBox value={time.days} label="DAYS" />
            <TimeBox value={time.hours} label="HRS" />
            <TimeBox value={time.minutes} label="MIN" />
            <TimeBox value={time.seconds} label="SEC" glitch />
        </div>
    );
}

function TimeBox({ value, label, glitch }) {
    return (
        <div className={`time-box ${glitch ? "glitch-sec" : ""}`}>
            <span>{String(value).padStart(2, "0")}</span>
            <p>{label}</p>
        </div>
    );
}